import { Injectable } from '@angular/core';
import { ApiSendService } from '@global-services/ApiSend.service';
import { ApiUrlEnum } from '@global-models/ApiUrlEnum';
import { ParameterAllRequestModel } from '@global-models/Request/ParameterAllRequestModel';
import { ParameterAllResponseModel } from '@global-models/Response/ParameterAllResponseModel';
import { AppHelper } from '@shared-helpers/app-helper';


@Injectable()
export class ParameterService {
  constructor(private _apiservice: ApiSendService) {
  }

  public getParameterGroup(name: string) {
    return this._apiservice.GetAuthorization(ApiUrlEnum.Ticari, '/api/Parameter/GetParameterGroupByName?name=' + name);
  }

  public GetCountries() {
    return this._apiservice.GetAuthorization(ApiUrlEnum.BackOffice, '/api/Location/GetCountries');
  }

  public GetAllParamaterList(model: ParameterAllRequestModel) {
    return this._apiservice.PostAuthorization(ApiUrlEnum.Ticari, '/api/Parameter/GetAllParamaterList', model);
  }

  public GetCachedParameters(): Array<ParameterAllResponseModel> {
    try {
      const cached = JSON.parse(localStorage.getItem('AllParameters'));
      return Array.isArray(cached) ? cached.filter(x => this.IsParameter(x)) : [];
    } catch { return []; }
  }

  public GetMissingGroups(parameters: Array<ParameterAllResponseModel>, groups: Array<string>): Array<string> {
    return groups.filter(group => !parameters.some(x => x.ParameterGroupName === group));
  }

  // AllParameters belongs to the whole portal, not only the currently open form.
  public async LoadParameters(refreshGroups: Array<string> = []): Promise<Array<ParameterAllResponseModel>> {
    const cached = this.GetCachedParameters();
    const portalGroups = AppHelper.GetParameterList().ParameterGroupNameList as Array<string>;
    const requestedGroups = Array.from(new Set([
      ...this.GetMissingGroups(cached, portalGroups), ...refreshGroups
    ]));
    if (requestedGroups.length === 0) { return cached; }

    const sessionContext = localStorage.getItem('DashboardUser');
    const request = new ParameterAllRequestModel();
    request.ParameterGroupNameList = requestedGroups;
    const response = await this.GetAllParamaterList(request);
    if (!Array.isArray(response) || response.some(x => !this.IsParameter(x))) {
      throw new Error('Parametre servisi geçerli bir liste döndürmedi.');
    }
    if (localStorage.getItem('DashboardUser') !== sessionContext) {
      throw new Error('Parametreler yüklenirken oturum değişti. Lütfen tekrar deneyiniz.');
    }

    const refreshed = (response as Array<ParameterAllResponseModel>)
      .filter(x => requestedGroups.includes(x.ParameterGroupName));
    // Read again after await: another form/login may have completed a refresh meanwhile.
    const latest = this.GetCachedParameters();
    if (refreshed.length === 0) { return latest; }
    const refreshedGroups = new Set(refreshed.map(x => x.ParameterGroupName));
    const merged = latest.filter(x => !refreshedGroups.has(x.ParameterGroupName)).concat(refreshed);
    // A full browser storage must not discard a successful API response for this form.
    try {
      localStorage.setItem('AllParameters', JSON.stringify(merged));
    } catch { /* The form can still use the returned in-memory list. */ }
    return merged;
  }

  private IsParameter(value: any): boolean {
    return value != null && typeof value.ParameterGroupName === 'string' &&
      value.ParameterGroupName.length > 0 && value.Code != null;
  }

}
